module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert":{"alreadyLoggedIn":"A user is already logged in. Please refresh the page to continue.","changePassword":"Your password is shorter than 10 characters. To protect your account, please change your password to make it longer."},"problem":{"401_2":"Incorrect email address and/or password."}}}')
  delete Component.options._Ctor
}
